// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"ff860200","212":"af2f473f","303":"0acb9df6","396":"e0240847","421":"25b1d5ea","655":"493e975e"}[chunkId] + ".chunk.css";
};